/* eslint-disable quote-props */
import moment from 'moment';
import { createHttpClient } from '../utils/httpUtils';

class baseCalendarExceptionDaysService {
  constructor() {
    this.http = createHttpClient();
  }

  async show(BaseCalendarId) {
    const res = await this.http
      .get('BaseCalendarexceptiondayss/' + BaseCalendarId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async destroy(BaseCalendarId) {
    const res = await this.http
      .delete('BaseCalendarexceptiondayss/' + BaseCalendarId)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async create(data) {
    const copy = { ...data };
    copy.from_date = moment(data.from_date).format('YYYY/MM/DD H:mm');
    copy.to_date = moment(data.to_date).format('YYYY/MM/DD H:mm');
    const res = await this.http
      .post('BaseCalendarexceptiondayss/', copy)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }

  async update(data) {
    const res = await this.http
      .put('BaseCalendarexceptiondayss/' + data.id, data)
      .catch((error) => {
        console.log(error.response);
        return false;
      });
    return res ? res.data : res;
  }
}

export const BaseCalendarExceptionDaysService =
  new baseCalendarExceptionDaysService();
